export default () => ({
  isContentLoaded: false,
  titleContent: {},
  cardContent: {},
});
